<template lang="pug">
.tabela-nota-fiscal.view-container
    h2.titulo Listagem de fazendas
    el-table(
        :data='dadosTabela',
        highlight-current-row,
        stripe,
        style='width: 100%; min-height: 371px'
        @row-click="handleRowClick"
    )
        el-table-column(label='Número Lote de produção', prop='loteProducao', min-width='150px', sortable)
            template(slot-scope='scope')
                span {{ scope.row.loteProducao }}

        el-table-column(label='Fundo', prop='codigo', min-width='150px', sortable)
            template(slot-scope='scope')
                span {{ scope.row.codigo }}
        
        el-table-column(label='Consumo', prop='consumo', min-width='150px', sortable)
            template(slot-scope='scope')
                span {{ scope.row.consumo }}
        
        el-table-column(label='Ações', align='left')
            .template.d-flex.justify-content-left(slot-scope='scope')
                el-dropdown.action-button(trigger='click')
                    BaseButton(link)
                        i.el-icon-more
                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            icon='el-icon-view',
                            @click.native='handleClickAction(scope.row.idTerritorio)'
                        ) Visualizar protocolo socioambiental
    .tabela-rodape
        .tabela-rodape--esquerda
            p {{ paginacao.total }} fazendas

        .tabela-rodape--pagination
            el-pagination(
                small,
                layout='prev, pager, next',
                :page-size='paginacao.itensPorPagina',
                :current-page.sync='paginacao.pagina',
                :total='paginacao.total',
                @current-change='atualizarPagina(paginacao.pagina - 1)'
            )

</template>

<script>
import formatters from '@/utils/formatters';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'TabelaFazendasNotaFiscal',
    components: {
        BaseButton
    },
    emits: ['atualizar-tabela', 'atualizar-pagina', 'selecionar-territorio'],
    props: {
        dadosTabela: {
            type: Array,
            default: () => {}
        },
        paginacao: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
        }
    },

    data() {
        return {
            dados: {}
        };
    },

    methods: {
        formatAreaHaTableColumn(row, column, areaHa, index) {
            return formatters.maxFormatNumber(areaHa, 2);
        },
        handleRowClick(row) {
            this.$emit('selecionar-territorio', row.idTerritorio);
        },
        handleClickAction(id) {
            window.location.replace('#/territorio/socioambiental/' + id);
        }
    }
};
</script>

<style lang="scss">

.titulo {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #1E1E1E;
}

.tabela-selecionar-territorio-monitoramento {
    h3 {
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .el-table {
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        border-radius: 6px;
    }
    .el-table thead {
        color: var(--primary);
        font-weight: 400;
        font-size: 13px;
    }

    .tabela-btn {
        margin-top: 14px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .el-dropdown-link {
        cursor: pointer;
    }
}

.tabela-rodape {
        height: 54px;
        background: var(--white);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 44% 10px 5px;
        margin-top: 8px;
        border-radius: 5px;

        .tabela-rodape--esquerda p {
            margin-bottom: 0;
            color: var(--primary);
            margin-left: 10px;
        }

        .tabela-rodape--pagination {
            .el-pager li.active {
                color: var(--white);
                font-weight: 900;
                background: var(--primary);
            }

            .el-pager li {
                padding: 0 4px;
                background: var(--white);
                vertical-align: top;
                display: inline-block;
                font-size: 13px !important;
                min-width: 28px !important;
                height: 28px !important;
                line-height: 28px !important;
                box-sizing: border-box;
                text-align: center;
                margin: 0;
                border-radius: 2px;
                color: var(--primary);
            }

            .el-pagination button {
                height: 28px;
            }
        }
    }
</style>
